var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AppComponentBase } from '../app-component-base';
import { SaveActionEnum } from './save-action-enum';
var LeaveEditPageWarningComponent = /** @class */ (function (_super) {
    __extends(LeaveEditPageWarningComponent, _super);
    function LeaveEditPageWarningComponent(injector, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.bsModalRef = bsModalRef;
        _this.onClosed = new EventEmitter();
        return _this;
    }
    LeaveEditPageWarningComponent.prototype.save = function () {
        this.close(SaveActionEnum.Save);
    };
    LeaveEditPageWarningComponent.prototype.unSave = function () {
        this.close(SaveActionEnum.UnSave);
    };
    LeaveEditPageWarningComponent.prototype.cancel = function () {
        this.close(SaveActionEnum.Cancel);
    };
    LeaveEditPageWarningComponent.prototype.close = function (value) {
        this.onClosed.emit(value);
        this.onClosed.complete();
        this.bsModalRef.hide();
    };
    __decorate([
        Input()
    ], LeaveEditPageWarningComponent.prototype, "name", void 0);
    __decorate([
        Output()
    ], LeaveEditPageWarningComponent.prototype, "onClosed", void 0);
    LeaveEditPageWarningComponent = __decorate([
        Component({
            template: "<div class=\"modal-content\"> <div class=\"fe-modal-container\"> <div class=\"fe-modal-header modal-border-bottom\"> <h4 class=\"fe-modal-header-title\"> {{l('Note')}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"cancel()\">×</div> </div> <div class=\"fe-modal-middle margin-top-10\"> <h5>{{name}}</h5> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"save()\"> {{l(\"Save\")}} </button> <button class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"unSave()\">{{l('UnSave')}}</button> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"cancel()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </div>",
            styles: [""]
        })
    ], LeaveEditPageWarningComponent);
    return LeaveEditPageWarningComponent;
}(AppComponentBase));
export { LeaveEditPageWarningComponent };
